<pane-card>
    <card-header ngProjectAs="card-header">Add Category</card-header>
    <card-folder #cardTop ngProjectAs="card-top-content">
        <icon-container
            ngProjectAs="folder-content"
            class="h-100">
            <svg-icon key="drag-drop"></svg-icon>
        </icon-container>
        <span
            ngProjectAs="caption"
            class="primary-text font-5">
            Drag & Drop Files/Revit Model
        </span>
    </card-folder>

    <card-content ngProjectAs="card-main-content">
        <category-details
            [category]="details"
            class="flex-grow-1" />
    </card-content>

    <card-content #cardBottom ngProjectAs="card-bottom-content">
        <form-dialog-standard-submit-buttons
            footer
            style="position: sticky"
            class="mt-auto"
            actionButtonName="Add"
            closeBtnName="Cancel"
            [isBusy]="submitCommand.isBusy() || details.isPending()"
            [isValid]="submitCommand.isValid()"
            (cancel)="cancelCommand.execute()"
            (submit)="submitCommand.execute()" />
    </card-content>
</pane-card>
